import { render, staticRenderFns } from "./PopperField.vue?vue&type=template&id=e04dafac&scoped=true&"
import script from "./PopperField.vue?vue&type=script&lang=js&"
export * from "./PopperField.vue?vue&type=script&lang=js&"
import style0 from "./PopperField.vue?vue&type=style&index=0&id=e04dafac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04dafac",
  null
  
)

export default component.exports